import { Card } from 'Card';
import { Text } from 'Text';
import { type LearnerProject } from 'LearnerProjects/LearnerProjects.types';
import { useProjectStatusConfig } from 'LearnerProjects/useProjectStatusConfig';
import { ProjectModalProvider } from 'LearnerProjects/ProjectModalContext';
import { type ProjectStatusModalHandlers } from 'LearnerProjects/useProjectStatusConfig.types';
import { useMemo } from 'react';
import 'LearnerProjects/locales/learnerProjects/learnerProjects-en.json';

export const useProjectContentBoxExpandedContent = ({
    project,
    modalHandlers,
}: {
    project: LearnerProject;
    modalHandlers: ProjectStatusModalHandlers;
}) => {
    const { text, content, icon } = useProjectStatusConfig(project);

    const expandedContent = useMemo(
        () => (
            <ProjectModalProvider modalHandlers={modalHandlers}>
                <Card className="rounded-none border-none">
                    <div className="flex flex-col gap-5">
                        <Text color="slate-grey">{text}</Text>
                        {content && <>{content}</>}
                    </div>
                </Card>
            </ProjectModalProvider>
        ),
        [text, content, modalHandlers],
    );

    return { expandedContent, icon };
};
